import { httpClient } from "../http/httpClient";
import { PartnerType } from "@/app/utils/partners.enum";
import { TriStateEnum } from "@/app/entities/TriState";

export type PatchConfigProductsRequest = {
  type: PartnerType;
  state: TriStateEnum;
  isActive: boolean;
  delay?: number;
};

export type PatchConfigProductsResponse = {
  success: boolean;
};

export const patchConfigProducts = async (body: PatchConfigProductsRequest) => {
  const { data } = await httpClient
    .patch<PatchConfigProductsResponse>("/config/products", body)
    .catch((error) => {
      throw error?.response?.data || error;
    });

  return data;
};
